import React, { useState } from "react";
import BuyPlan from "./PlanPurchase/BuyPlan";
import { Link } from "react-router-dom";
import SVG from "../components/SVG";

const PlanPage = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [planCode, setPlanCode] = useState("");
  const [tenantId, setTenantId] = useState("T3341001XT8");
  const [isRider, setIsRider] = useState(false);
  const [showMember, setShowMember] = useState(false);
  const [memberCount, setMemberCount] = useState(0);
  // const [showRC, setShowRC] = useState(false);

  return (
    <main>
      {/* Page Banner */}
      <div className="page-banner overlay">
        <picture className="media media-bg max-md:!hidden">
          <img
            src="assets/img/banner/page-banner.jpg"
            width={1920}
            height={520}
            loading="eager"
            alt="Page Banner Image"
          />
        </picture>
        <div className="page-banner-content">
          <div className="container text-center">
            <h1 className="heading text-80 fw-700 max-md:!text-[30px]">
              Plans
            </h1>
            <ul
              className="breadcrumb list-unstyled"
            >
              <li>
                <a
                  href="/"
                  className="text text-18"
                  aria-label="Home Page"
                >
                  Home
                </a>
              </li>
              <li>
                <svg
                  width={8}
                  height={12}
                  viewBox="0 0 8 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.08929 5.40903C7.24552 5.5653 7.33328 5.77723 7.33328 5.9982C7.33328 6.21917 7.24552 6.43109 7.08929 6.58736L2.37512 11.3015C2.29825 11.3811 2.2063 11.4446 2.10463 11.4883C2.00296 11.532 1.89361 11.5549 1.78296 11.5559C1.67231 11.5569 1.56258 11.5358 1.46016 11.4939C1.35775 11.452 1.2647 11.3901 1.18646 11.3119C1.10822 11.2336 1.04634 11.1406 1.00444 11.0382C0.962537 10.9357 0.941453 10.826 0.942414 10.7154C0.943376 10.6047 0.966364 10.4954 1.01004 10.3937C1.05371 10.292 1.1172 10.2001 1.19679 10.1232L5.32179 5.9982L1.19679 1.8732C1.04499 1.71603 0.960996 1.50553 0.962894 1.28703C0.964793 1.06853 1.05243 0.859522 1.20694 0.705015C1.36145 0.550508 1.57046 0.462868 1.78896 0.460969C2.00745 0.45907 2.21795 0.543066 2.37512 0.694864L7.08929 5.40903Z"
                    fill="currentColor"
                  />
                </svg>
              </li>
              <li>
                <a role="link" aria-disabled="true" className="text text-18 active">
                  Plans
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* ======= Pricing =======*/}
      <section className="section pricing__v2 cu_mtpd py-[80px]" id="pricing">
        <div className="container">
          <div className="section-content">
            <div className="pricing-cards">
              <div className="grid grid-cols-12 lg:gap-1 product-grid justify-content-center items-stretch">
                {/* Plan 1 */}
                <div className="col-span-12 lg:col-span-12 xl:col-span-6">
                  <div className="card-pricing radius18 h-full flex flex-col">
                    <div className="card-pricing-headings radius18">
                      <h2 className="heading text-24 mb-2">Aarogya EasyCare</h2>
                      <div className="py-2 px-4 text-[#0657a3] bg-[#d4ebff] rounded-[8px] w-fit">Member Coverage: Individual</div>
                      <div className="pricing-box">
                        <span className="subheading text-50 fw-600">₹1299</span>
                        <span className="subheading subheading-monthly text-16 fw-400">
                          + GST
                        </span>
                      </div>
                    </div>

                    <ul className="text-lists list-unstyled">
                      <li className="text-item text text-18" ><SVG /> 10 Credits on Tele Doctor Consultation: GP</li>
                      <li className="text-item text text-18" ><SVG /> 2 Credits on Video Consultation-General Physician</li>
                    </ul>

                    <div>
                      <h2 className="heading text-[18px] mb-1">Group Personal Accident Rider</h2>
                      <p className="font-mendium text-[14px] mb-[30px]">(Only for Primary Member)</p>
                      <ul className="text-lists list-unstyled">
                        <li className="text-item text text-18" ><SVG /> ₹15 Lakh Sum Insured</li>
                        <li className="text-item text text-18" ><SVG /> Covered Accidental Death</li>
                        <li className="text-item text text-18" ><SVG /> Covered Permanent Total Disability (Upto 100% SI Paid on PTD)</li>
                      </ul>
                    </div>

                    <div>
                      <h2 className="heading text-[18px] mb-[30px]">Inclusive Benefits</h2>
                      <ul className="text-lists list-unstyled">
                        <li className="text-item text text-18" ><SVG /> Applicable Risk Assessment</li>
                        <li className="text-item text text-18" ><SVG /> Applicable Health Reminder</li>
                        <li className="text-item text text-18" ><SVG /> Applicable Recorded Fitness sessions</li>
                      </ul>
                    </div>

                    <div>
                      <h2 className="heading text-[18px] mb-[30px]">Platform Benefits</h2>
                      <ul className="text-lists list-unstyled">
                        <li className="text-item text text-18" ><SVG /> Covered Upto 50% off on diagnostic test & packages (20000 diagnostics test up 50% discount)</li>
                        <li className="text-item text text-18" ><SVG /> Covered Upto 20% off on prescribed medicines</li>
                      </ul>
                    </div>

                    <div>*Note: This plan applicable for the age from 18 - 65 years</div>

                    <div className="buttons mt-auto">
                      <div
                        className="button button--primary"
                        aria-label="Purchase Plan"
                        onClick={() => {
                          setPlanCode("AEC001");
                          setOpenPopup(true);
                          setIsRider(true);
                          setMemberCount(0);
                          setShowMember(false);
                        }}
                      >
                        Buy Plan
                        <svg
                          viewBox="0 0 11 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.16668 0.833333C2.16668 0.61232 2.25448 0.400358 2.41076 0.244078C2.56704 0.0877975 2.779 0 3.00001 0H9.66668C9.88769 0 10.0997 0.0877975 10.2559 0.244078C10.4122 0.400358 10.5 0.61232 10.5 0.833333V7.5C10.5 7.72101 10.4122 7.93297 10.2559 8.08926C10.0997 8.24554 9.88769 8.33333 9.66668 8.33333C9.44567 8.33333 9.2337 8.24554 9.07742 8.08926C8.92114 7.93297 8.83335 7.72101 8.83335 7.5V2.845L1.92251 9.75583C1.76535 9.90763 1.55484 9.99163 1.33635 9.98973C1.11785 9.98783 0.908839 9.90019 0.754332 9.74568C0.599825 9.59118 0.512184 9.38216 0.510285 9.16367C0.508387 8.94517 0.592382 8.73467 0.744181 8.5775L7.65501 1.66667H3.00001C2.779 1.66667 2.56704 1.57887 2.41076 1.42259C2.25448 1.26631 2.16668 1.05435 2.16668 0.833333Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Plan 2 */}
                <div className="col-span-12 lg:col-span-12 xl:col-span-6">
                  <div className="card-pricing radius18 h-full flex flex-col">
                    <div className="card-pricing-headings radius18">
                      <h2 className="heading text-24 mb-2">Aarogya SmartCare</h2>
                      <div className="py-2 px-4 text-[#0657a3] bg-[#d4ebff] rounded-[8px] w-fit">Member Coverage: 2 Adults</div>
                      <div className="pricing-box">
                        <span className="subheading text-50 fw-600">₹2699</span>
                        <span className="subheading subheading-monthly text-16 fw-400">
                          + GST
                        </span>
                      </div>
                    </div>

                    <ul className="text-lists list-unstyled">
                      <li className="text-item text text-18" ><SVG /> 10 Credits on Tele Doctor Consultation: GP</li>
                      <li className="text-item text text-18" ><SVG /> 4 Credits on Tele Consultation (18 Specialist)</li>
                      <li className="text-item text text-18" ><SVG /> 4 Credits on Video Consultation-General Physician</li>
                    </ul>

                    <div>
                      <h2 className="heading text-[18px] mb-1">Group Personal Accident Rider</h2>
                      <p className="font-mendium text-[14px] mb-[30px]">(Only for Primary Member)</p>
                      <ul className="text-lists list-unstyled">
                        <li className="text-item text text-18" ><SVG /> ₹15 Lakh Sum Insured</li>
                        <li className="text-item text text-18" ><SVG /> Covered Accidental Death</li>
                        <li className="text-item text text-18" ><SVG /> Covered Permanent Total Disability (Upto 100% SI Paid on PTD)</li>
                      </ul>
                    </div>

                    <div>
                      <h2 className="heading text-[18px] mb-[30px]">Inclusive Benefits</h2>
                      <ul className="text-lists list-unstyled">
                        <li className="text-item text text-18" ><SVG /> Applicable Risk Assessment</li>
                        <li className="text-item text text-18" ><SVG /> Applicable Health Reminder</li>
                        <li className="text-item text text-18" ><SVG /> Applicable Recorded Fitness sessions</li>
                      </ul>
                    </div>

                    <div>
                      <h2 className="heading text-[18px] mb-[30px]">Platform Benefits</h2>
                      <ul className="text-lists list-unstyled">
                        <li className="text-item text text-18" ><SVG /> Covered Upto 50% off on diagnostic test & packages (20000 diagnostics test up 50% discount)</li>
                        <li className="text-item text text-18" ><SVG /> Covered Upto 20% off on prescribed medicines</li>
                      </ul>
                    </div>

                    <div>*Note: This plan applicable for the age from 18 - 65 years</div>

                    <div className="buttons mt-auto">
                      <div
                        className="button button--primary"
                        aria-label="Purchase Plan"
                        onClick={() => {
                          setPlanCode("ASC001");
                          setOpenPopup(true);
                          setIsRider(true);
                          setMemberCount(1);
                          setShowMember(false);
                        }}
                      >
                        Buy Plan1
                        <svg
                          viewBox="0 0 11 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.16668 0.833333C2.16668 0.61232 2.25448 0.400358 2.41076 0.244078C2.56704 0.0877975 2.779 0 3.00001 0H9.66668C9.88769 0 10.0997 0.0877975 10.2559 0.244078C10.4122 0.400358 10.5 0.61232 10.5 0.833333V7.5C10.5 7.72101 10.4122 7.93297 10.2559 8.08926C10.0997 8.24554 9.88769 8.33333 9.66668 8.33333C9.44567 8.33333 9.2337 8.24554 9.07742 8.08926C8.92114 7.93297 8.83335 7.72101 8.83335 7.5V2.845L1.92251 9.75583C1.76535 9.90763 1.55484 9.99163 1.33635 9.98973C1.11785 9.98783 0.908839 9.90019 0.754332 9.74568C0.599825 9.59118 0.512184 9.38216 0.510285 9.16367C0.508387 8.94517 0.592382 8.73467 0.744181 8.5775L7.65501 1.66667H3.00001C2.779 1.66667 2.56704 1.57887 2.41076 1.42259C2.25448 1.26631 2.16668 1.05435 2.16668 0.833333Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Plan 3 */}
                <div className="col-span-12 lg:col-span-12 xl:col-span-6">
                  <div className="card-pricing radius18 h-full flex flex-col">
                    <div className="card-pricing-headings radius18">
                      <h2 className="heading text-24 mb-2">Aarogya TotalCare</h2>
                      <div className="py-2 px-4 text-[#0657a3] bg-[#d4ebff] rounded-[8px] w-fit">Member Coverage: 4 Adults</div>
                      <div className="pricing-box">
                        <span className="subheading text-50 fw-600">₹5199</span>
                        <span className="subheading subheading-monthly text-16 fw-400">
                          + GST
                        </span>
                      </div>
                    </div>

                    <ul className="text-lists list-unstyled">
                      <li className="text-item text text-18" ><SVG /> 12 Credits on Tele Doctor Consultation: GP</li>
                      <li className="text-item text text-18" ><SVG /> 4 Credits on Tele Doctor Consultation: Ayurvedic</li>
                      <li className="text-item text text-18" ><SVG /> 4 Credits on Tele Doctor Consultation: Homeopathy</li>
                      <li className="text-item text text-18" ><SVG /> 4 Credits on Tele Consultation (18 Specialist)</li>
                      <li className="text-item text text-18" ><SVG /> 6 Credits on Video Consultation-General Physician</li>
                      <li className="text-item text text-18" ><SVG /> 2 Credits on Dental Checkup & Consultation</li>
                      <li className="text-item text text-18" ><SVG /> 2 Credits on Mental Wellness</li>
                      <li className="text-item text text-18" ><SVG /> 2 Credits on Dietician Consultation</li>
                    </ul>

                    <div>
                      <h2 className="heading text-[18px] mb-1">Group Personal Accident Rider</h2>
                      <p className="font-mendium text-[14px] mb-[30px]">(Only for Primary Member)</p>
                      <ul className="text-lists list-unstyled">
                        <li className="text-item text text-18" ><SVG /> ₹15 Lakh Sum Insured</li>
                        <li className="text-item text text-18" ><SVG /> Covered Accidental Death</li>
                        <li className="text-item text text-18" ><SVG /> Covered Permanent Total Disability (Upto 100% SI Paid on PTD)</li>
                      </ul>
                    </div>

                    <div>
                      <h2 className="heading text-[18px] mb-[30px]">Inclusive Benefits</h2>
                      <ul className="text-lists list-unstyled">
                        <li className="text-item text text-18" ><SVG /> Applicable Risk Assessment</li>
                        <li className="text-item text text-18" ><SVG /> Applicable Health Reminder</li>
                        <li className="text-item text text-18" ><SVG /> Applicable Recorded Fitness sessions</li>
                      </ul>
                    </div>

                    <div>
                      <h2 className="heading text-[18px] mb-[30px]">Platform Benefits</h2>
                      <ul className="text-lists list-unstyled">
                        <li className="text-item text text-18" ><SVG /> Covered Upto 50% off on diagnostic test & packages (20000 diagnostics test up 50% discount)</li>
                        <li className="text-item text text-18" ><SVG /> Covered Upto 20% off on prescribed medicines</li>
                      </ul>
                    </div>

                    <div>*Note: This plan applicable for the age from 0 - 85 years</div>

                    <div className="buttons mt-auto">
                      <div
                        className="button button--primary"
                        aria-label="Purchase Plan"
                        onClick={() => {
                          setPlanCode("ATC001");
                          setOpenPopup(true);
                          setIsRider(true);
                          setMemberCount(3);
                          setShowMember(false);
                        }}
                      >
                        Buy Plan
                        <svg
                          viewBox="0 0 11 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.16668 0.833333C2.16668 0.61232 2.25448 0.400358 2.41076 0.244078C2.56704 0.0877975 2.779 0 3.00001 0H9.66668C9.88769 0 10.0997 0.0877975 10.2559 0.244078C10.4122 0.400358 10.5 0.61232 10.5 0.833333V7.5C10.5 7.72101 10.4122 7.93297 10.2559 8.08926C10.0997 8.24554 9.88769 8.33333 9.66668 8.33333C9.44567 8.33333 9.2337 8.24554 9.07742 8.08926C8.92114 7.93297 8.83335 7.72101 8.83335 7.5V2.845L1.92251 9.75583C1.76535 9.90763 1.55484 9.99163 1.33635 9.98973C1.11785 9.98783 0.908839 9.90019 0.754332 9.74568C0.599825 9.59118 0.512184 9.38216 0.510285 9.16367C0.508387 8.94517 0.592382 8.73467 0.744181 8.5775L7.65501 1.66667H3.00001C2.779 1.66667 2.56704 1.57887 2.41076 1.42259C2.25448 1.26631 2.16668 1.05435 2.16668 0.833333Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Plan 4 */}
                <div className="col-span-12 lg:col-span-12 xl:col-span-6">
                  <div className="card-pricing radius18 h-full flex flex-col">
                    <div className="card-pricing-headings radius18">
                      <h2 className="heading text-24 mb-2">Aarogya EliteCare</h2>
                      <div className="py-2 px-4 text-[#0657a3] bg-[#d4ebff] rounded-[8px] w-fit">Member Coverage: 4 Adults</div>
                      <div className="pricing-box">
                        <span className="subheading text-50 fw-600">₹10199</span>
                        <span className="subheading subheading-monthly text-16 fw-400">
                          + GST
                        </span>
                      </div>
                    </div>

                    <ul className="text-lists list-unstyled">
                      <li className="text-item text text-18" ><SVG /> 12 Credits on Tele Doctor Consultation: GP</li>
                      <li className="text-item text text-18" ><SVG /> 4 Credits on Tele Doctor Consultation: Ayurvedic</li>
                      <li className="text-item text text-18" ><SVG /> 4 Credits on Tele Doctor Consultation: Homeopathy</li>
                      <li className="text-item text text-18" ><SVG /> 6 Credits on Tele Consultation (18 Specialist)</li>
                      <li className="text-item text text-18" ><SVG /> 2 Credits on Instant Doctor Consultation</li>
                      <li className="text-item text text-18" ><SVG /> ₹1000 on Diagnostic & Radiology Wallet</li>
                      <li className="text-item text text-18" ><SVG /> 8 Credits on Video Consultation-General Physician</li>
                      <li className="text-item text text-18" ><SVG /> 2 Credits on Dental Checkup & Consultation</li>
                      <li className="text-item text text-18" ><SVG /> 2 Credits on Mental Wellness</li>
                      <li className="text-item text text-18" ><SVG /> 2 Credits on Dietician Consultation</li>
                    </ul>

                    <div>
                      <h2 className="heading text-[18px] mb-1">Group Personal Accident Rider</h2>
                      <p className="font-mendium text-[14px] mb-[30px]">(Only for Primary Member)</p>
                      <ul className="text-lists list-unstyled">
                        <li className="text-item text text-18" ><SVG /> ₹15 Lakh Sum Insured Cover 2 People</li>
                        <li className="text-item text text-18" ><SVG /> Covered Accidental Death</li>
                        <li className="text-item text text-18" ><SVG /> Covered Permanent Total Disability (Upto 100% SI Paid on PTD)</li>
                      </ul>
                    </div>

                    <div>
                      <h2 className="heading text-[18px] mb-[30px]">Inclusive Benefits</h2>
                      <ul className="text-lists list-unstyled">
                        <li className="text-item text text-18" ><SVG /> Applicable Risk Assessment</li>
                        <li className="text-item text text-18" ><SVG /> Applicable Health Reminder</li>
                        <li className="text-item text text-18" ><SVG /> Applicable Recorded Fitness sessions</li>
                      </ul>
                    </div>

                    <div>
                      <h2 className="heading text-[18px] mb-[30px]">Platform Benefits</h2>
                      <ul className="text-lists list-unstyled">
                        <li className="text-item text text-18" ><SVG /> Covered Upto 50% off on diagnostic test & packages (20000 diagnostics test up 50% discount)</li>
                        <li className="text-item text text-18" ><SVG /> Covered Upto 20% off on prescribed medicines</li>
                      </ul>
                    </div>

                    <div>*Note: This plan applicable for the age from 0 - 85 years</div>

                    <div className="buttons mt-auto">
                      <div
                        className="button button--primary"
                        aria-label="Purchase Plan"
                        onClick={() => {
                          setPlanCode("AarogyaEliteCare");
                          setOpenPopup(true);
                          setIsRider(true);
                          setMemberCount(3);
                          setShowMember(false);
                        }}
                      >
                        Buy Plan
                        <svg
                          viewBox="0 0 11 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.16668 0.833333C2.16668 0.61232 2.25448 0.400358 2.41076 0.244078C2.56704 0.0877975 2.779 0 3.00001 0H9.66668C9.88769 0 10.0997 0.0877975 10.2559 0.244078C10.4122 0.400358 10.5 0.61232 10.5 0.833333V7.5C10.5 7.72101 10.4122 7.93297 10.2559 8.08926C10.0997 8.24554 9.88769 8.33333 9.66668 8.33333C9.44567 8.33333 9.2337 8.24554 9.07742 8.08926C8.92114 7.93297 8.83335 7.72101 8.83335 7.5V2.845L1.92251 9.75583C1.76535 9.90763 1.55484 9.99163 1.33635 9.98973C1.11785 9.98783 0.908839 9.90019 0.754332 9.74568C0.599825 9.59118 0.512184 9.38216 0.510285 9.16367C0.508387 8.94517 0.592382 8.73467 0.744181 8.5775L7.65501 1.66667H3.00001C2.779 1.66667 2.56704 1.57887 2.41076 1.42259C2.25448 1.26631 2.16668 1.05435 2.16668 0.833333Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
      {/* End Pricing*/}

      <BuyPlan
        planCode={planCode}
        tenantId={tenantId}
        showPopUp={openPopup}
        setShowPopUp={setOpenPopup}
        isRider={isRider}
        showMember={showMember}
        memberCount={memberCount}
        // showRC={showRC}
      />
    </main>
  );
};

export default PlanPage;
